export default __webpack_public_path__ + "static/media/swoosh.975aadb0.svg";